module.exports = __webpack_public_path__ + "img/Result_MidHigh_0608_01_2.6954a08c.png";